<template>
  <div style="padding-left: 35px; padding-right: 35px">
    <v-row style="background-color: #fff; padding: 30px">
      <v-col cols="2">
        <v-icon large icon="mdi-arrow-left" @click="$router.push('/config')" style="font-size: 46px"
          >mdi-arrow-left</v-icon
        >
      </v-col>
      <v-col cols="8" style="text-align: center !important; margin-bottom: 20px">
        <v-typography style="text-transform: uppercase; letter-spacing: 5px"> Logbooks config </v-typography>
      </v-col>
      <v-divider></v-divider>
      <v-row align="center" justify="space-between" class="mt-4">
        <v-col cols="auto" class="flex-grow-1" style="flex: 0 0 70%">
          <v-text-field
            v-model="search"
            label="Search existing logbooks"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            density="comfortable"
            style="height: 55px"
          ></v-text-field>
        </v-col>

        <v-col cols="auto">
          <v-btn outlined color="#000" class="mt-4 mb-4" style="height: 50px; display: flex; align-items: center">
            <v-icon start>mdi-plus</v-icon>
            NEW Logbook
            <v-dialog activator="parent" persistent>
              <template v-slot:default="{ isActive }">
                <v-card class="mx-auto" flat min-width="560" style="padding: 45px !important; text-align: center">
                  <template v-slot:title>
                    <span>Add new logbook</span>
                  </template>

                  <v-card-text class="mt-5 text-center">
                    <v-text-field variant="outlined" label="Logbook name" v-model="newName"></v-text-field>
                    <v-text-field
                      variant="outlined"
                      label="Logbook description"
                      v-model="newDescription"
                    ></v-text-field>
                  </v-card-text>

                  <template v-slot:actions>
                    <div class="d-flex justify-center">
                      <v-btn
                        variant="elevated"
                        color="#3c6d72"
                        style="width: 220px; margin-right: 10px"
                        @click="addNewLogbook(newName, newDescription, isActive)"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        @click="
                          isActive.value = false;
                          newName = '';
                          newDescription = '';
                        "
                        variant="tonal"
                        style="width: 220px; margin-left: 10px"
                      >
                        Cancel
                      </v-btn>
                    </div>
                  </template>
                </v-card>
              </template>
            </v-dialog>
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table :items="logbooks" :headers="headers" :loading="loadingLogbooks" :search="search">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              <div class="d-flex">
                <v-btn
                  style="text-transform: capitalize; font-size: 12px"
                  stacked
                  variant="text"
                  @click="viewSelectedLogbook(item.id)"
                >
                  <span style="display: flex">
                    <v-icon size="16" class="mb-2">mdi-eye</v-icon>
                  </span>
                  View
                </v-btn>
                <div
                  style="margin: auto; height: 40px; border-left: 2px solid #e0e0e0; margin-left: 0; margin-right: 0"
                ></div>
                <v-btn
                  style="text-transform: capitalize; font-size: 12px"
                  stacked
                  variant="text"
                  @click="editSelectedLogbook(item.id)"
                >
                  <v-icon size="16" class="mb-2">mdi-pencil</v-icon>
                  Edit
                </v-btn>
                <div
                  style="margin: auto; height: 40px; border-left: 2px solid #e0e0e0; margin-left: 0; margin-right: 0"
                ></div>
                <v-btn style="text-transform: capitalize; font-size: 12px" stacked variant="text">
                  <span style="display: flex">
                    <v-icon size="16" class="mb-2">mdi-delete</v-icon>
                  </span>
                  Delete
                  <v-dialog activator="parent" persistent>
                    <template v-slot:default="{ isActive }">
                      <v-card class="mx-auto" flat min-width="560" style="padding: 45px !important; text-align: center">
                        <template v-slot:title>
                          <span
                            >Are you sure you want to delete <strong>{{ item.name }}</strong
                            >?</span
                          >
                        </template>

                        <template v-slot:actions>
                          <div class="d-flex justify-center">
                            <v-btn
                              variant="elevated"
                              color="#3c6d72"
                              style="width: 220px; margin-right: 10px"
                              @click="deleteSelectedLogbook(item.id, item.name, isActive)"
                            >
                              Submit
                            </v-btn>
                            <v-btn
                              @click="isActive.value = false"
                              variant="tonal"
                              style="width: 220px; margin-left: 10px"
                            >
                              Cancel
                            </v-btn>
                          </div>
                        </template>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar.showing" :timeout="timeout" :color="snackbar.ok ? 'green' : 'red'">
        <div style="text-align: center">
          {{ snackbar.text }}
        </div>
      </v-snackbar>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      loadingLogbooks: false,
      newName: "",
      newDescription: "",
      headers: [
        {
          align: "start",
          key: "id",
          sortable: false,
          title: "ID",
        },
        { key: "name", title: "Name" },
        { key: "description", title: "Description" },
        { key: "options", title: "" },
      ],
      logbooks: [],
      snackbar: { text: "text", ok: true, showing: false },
      timeout:3000,
    };
  },

  mounted() {
    this.getLogbooks();
  },

  methods: {
    async getLogbooks() {
      this.loadingLogbooks = true;
      await axios
        .get("/apiv1/my-logbooks")
        .then((res) => {
          console.log(res);
          this.logbooks = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.loadingLogbooks = false;
        });
      this.loadingLogbooks = false;
    },

    async editSelectedLogbook(id) {
      this.$router.push("/demoedit/" + id);
    },

    async viewSelectedLogbook(id) {
      this.$router.push("/logbook/" + id);
    },

    async addNewLogbook(name, description, isActive) {
      await axios
        .post("/apiv1/make", { name: name, description: description })
        .then((res) => {
          console.log(res);
          isActive.value = false;
          this.getLogbooks();
          this.snackbarMsg(name + " successfully added", true);
        })
        .catch((err) => {
          console.log(err);
          this.snackbarMsg(name + " could not be added", false);
        });
      isActive.value = false;
    },

    async deleteSelectedLogbook(id, name, isActive) {
      axios
        .delete(`apiTEST/logbook/${id}`)
        .then((response) => {
          isActive.value = false;
          this.getLogbooks();
          this.snackbarMsg(name + " successfully deleted", true);
          console.log("Logbook deleted:", id, response);
        })
        .catch((error) => {
          this.snackbarMsg(name + " could not be deleted", false);
          console.error("Error deleting logbook:", error);
        });
    },

    snackbarMsg(message, ok) {
      this.snackbar.text = message;
      this.snackbar.ok = ok;
      this.snackbar.showing = true;
    },
  },
};
</script>

<style scoped>
.subitem-selected {
  background-color: rgba(60, 109, 114, 0.2);
}

.buildingRow:hover {
  background-color: rgba(23, 67, 53, 0.05);
}
</style>
